import { VendorsCountWidgetProps } from "./VendorsCountWidget";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useVendorsCountWidget(props: VendorsCountWidgetProps) {
    let userContext = useUserContext();
    let url = `/legal-entities/dashboard/vendorscount?onlyUserSpecific=${props.onlyUserSpecific}`;
    const isEnabled =
        userContext.permissions.companyPermissions.read &&
        !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.ExternalLegalEntities);
    const { isLoading, data } = useDotLegalQuery<number>(url, {
        enabled: isEnabled,
    });

    return {
        isLoading,
        data,
        isEnabled,
    };
}
